/**
 * ScrollToTop Component
 *
 * Scrolls the window to the top whenever the route changes.
 * This ensures consistent UX when navigating between pages.
 *
 * @module components/scroll-to-top
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
